import React from 'react';
import { useMotion } from '@/lib/motion';

export default function GradientMesh({ enabled = true, intensity = 'normal' }) {
  const { motionAllowed, isMobile } = useMotion();
  if (!enabled) return null;
  // On mobile-simplified, render only 1 blob
  const blobs = isMobile ? 1 : 3;
  const reduced = !motionAllowed;
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden>
      {Array.from({ length: blobs }).map((_, i) => (
        <span
          key={i}
          className={`absolute rounded-full blur-3xl mix-blend-screen ${reduced ? '' : i === 0 ? 'motion-blob-a' : i === 1 ? 'motion-blob-b' : 'motion-blob-c'}`}
          style={{
            width: i === 0 ? 720 : i === 1 ? 880 : 620,
            height: i === 0 ? 720 : i === 1 ? 880 : 620,
            background: i === 1 ? 'radial-gradient(closest-side, rgba(184,38,26,0.28), transparent 70%)' : 'radial-gradient(closest-side, rgba(232,80,10,0.22), transparent 70%)',
            left: i === 0 ? '6%' : i === 1 ? '60%' : '30%',
            top: i === 0 ? '12%' : i === 1 ? '40%' : '70%',
            opacity: 0.85,
          }}
        />
      ))}
    </div>
  );
}
